import { Routes, RouterModule } from "@angular/router";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ApiService } from "./../services/api.service";
// import { ChartModule } from "angular-highcharts";
import { LandingPageComponent } from "./landing-page.component";
// import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { PersonProfileComponent } from "./directory/person-profile/person-profile.component";
import { PeopleDirectoryComponent } from "./directory/people-directory/people-directory.component";
import { MainSearchComponent } from "./search/search.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatButtonModule } from "@angular/material/button";
import { FarmSciReviewComponent } from "./fsr/farm-sci-review/farm-sci-review.component";
import { CommonModule } from "@angular/common";
import { FarmSciMapComponent } from "./fsr/farm-sci-map/farm-sci-map.component";
import { SharedModule } from "../shared/shared.module";
import { SearchHeaderComponent } from "./structure/search-header/search-header.component";
import { TopicRedirectComponent } from "./structure/topic-redirect/topic-redirect.component";
import { ScrollStoryComponent } from "./habri/scroll-story.component";
import { AboutNewComponent } from "./about/about.component";
// import { AnimateModule, AnimateService } from "@wizdm/animate";
import { MusicToolComponent } from "./music-tool/tool/music-tool.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MusicToolPageComponent } from "./music-tool/page/music-tool-page.component";
import { PlayButtonComponent } from "./music-tool/play-button/play-button.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatInputModule } from "@angular/material/input";
import { MatTableModule } from "@angular/material/table";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatChipsModule } from "@angular/material/chips";
import { MatSortModule } from "@angular/material/sort";
import { SearchCfaesComponent } from "./search-cfaes/search-cfaes.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatMenuModule } from "@angular/material/menu";
import { PanoramaComponent } from "../shared/components/panorama/panorama.component";
import { LandingPageHeaderComponent } from "./structure/landing-page-header/landing-page-header.component";
import { DataSetComponent } from "./data-sets/data-set/data-set.component";
import { DataCatalogComponent } from "./data-sets/data-catalog/data-catalog.component";
import { MatTabsModule } from "@angular/material/tabs";
import { FoodSystemVisualizationComponent } from "./food-system-visualization/food-system-visualization.component";
import { SimpleVisualizationComponent } from "./food-system-visualization/simple-visualization/simple-visualization.component";
import { InstructionsDialog } from "./food-system-visualization/instructions/instructions-dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatStepperModule } from "@angular/material/stepper";
import { MatRadioModule } from "@angular/material/radio";
import { DataItemComponent } from "./data-sets/data-item/data-item.component";
import { ContactUsComponent } from "./contact-us/contact-us.component";
import { CustomLandingPageComponent } from "../shared/custom-stuff/custom-landing-page/custom-landing-page.component";
import { DataTermsOfUseComponent } from "./data-terms-of-use/data-terms-of-use.component";
import { PanoHotspotPopupDialog } from "../shared/components/panorama/hotspot-popup.component";
import { SafeStylePipe } from "../pipes/safe-style.pipe";
import { ImpactsComponent } from "./impacts/impacts.component";
import { ExternalRedirectComponent } from "./external-redirect/external-redirect.component";
import { ExpertDirectoryComponent } from "./expert-directory/expert-directory.component";
import { DepartmentKeyPopupComponent } from "./expert-directory/department-key-popup/department-key-popup.component";
import { MobileTopComponent } from "./impacts/quote-svg-pieces/mobile-top.component";
import { BubbleBottomComponent } from "./impacts/quote-svg-pieces/bubble-bottom.component";
import { BubbleTopComponent } from "./impacts/quote-svg-pieces/bubble-top.component";

const routes: Routes = [
  { path: "", component: LandingPageComponent },
  {
    path: "",
    loadChildren: () =>
      import("./content/content.module").then((m) => m.ContentModule),
  },
  { path: "about", component: AboutNewComponent },
  { path: "impacts", component: ImpactsComponent },
  { path: "water-quality-composition", component: MusicToolPageComponent },
  { path: "habri-scrolling-visualization", component: ScrollStoryComponent },
  { path: "farm-sci-review", component: FarmSciReviewComponent },
  { path: "state-yield-tour", component: FarmSciMapComponent },
  { path: "search", component: MainSearchComponent },
  { path: "search/:term/:filter", component: MainSearchComponent },
  { path: "cfaes-search", component: SearchCfaesComponent },
  { path: "topics", redirectTo: "search", pathMatch: "full" },
  { path: "topic/:topic", component: TopicRedirectComponent },
  { path: "bucket/:bucketName", redirectTo: "search", pathMatch: "full" },
  { path: "directory", component: PeopleDirectoryComponent },
  { path: "directory/:name_n", component: PersonProfileComponent },
  {
    path: "directory/external/:external_id",
    component: PersonProfileComponent,
  },
  { path: "data-set/:title", component: DataSetComponent },
  { path: "data-catalog", component: DataCatalogComponent },
  { path: "pano/:id", component: PanoramaComponent },
  {
    path: "food-system-visualization",
    component: FoodSystemVisualizationComponent,
  },
  { path: "contact-us", redirectTo: "about", pathMatch: "full" },

  { path: "landing-page/:name", component: CustomLandingPageComponent },
  { path: "data-terms-of-use", component: DataTermsOfUseComponent },
  { path: "external/:external_url", component: ExternalRedirectComponent },
  {
    path: "drain",
    component: ExternalRedirectComponent,
    data: { externalUrl: "https://d2gasaulwelxaj.cloudfront.net/" },
  },
  { path: "expert-directory", component: ExpertDirectoryComponent },
];

@NgModule({
  declarations: [
    AboutNewComponent,
    LandingPageComponent,
    TopicRedirectComponent,
    ScrollStoryComponent,
    PersonProfileComponent,
    PeopleDirectoryComponent,
    MainSearchComponent,
    SearchHeaderComponent,
    FarmSciReviewComponent,
    FarmSciMapComponent,
    MusicToolComponent,
    MusicToolPageComponent,
    PlayButtonComponent,
    DataCatalogComponent,
    SearchCfaesComponent,
    LandingPageHeaderComponent,
    DataSetComponent,
    FoodSystemVisualizationComponent,
    SimpleVisualizationComponent,
    InstructionsDialog,
    DataItemComponent,
    ContactUsComponent,
    DataTermsOfUseComponent,
    ImpactsComponent,
    ExternalRedirectComponent,
    ExpertDirectoryComponent,
    DepartmentKeyPopupComponent,
    MobileTopComponent,
    BubbleBottomComponent,
    BubbleTopComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    // NgbModule,
    CommonModule,
    // ChartModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    DragDropModule,
    MatButtonModule,
    SharedModule,
    FormsModule,
    // AnimateModule,
    MatTooltipModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatInputModule,
    FormsModule,
    MatTableModule,
    MatIconModule,
    MatListModule,
    MatChipsModule,
    MatSortModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatChipsModule,
    MatListModule,
    MatRadioModule,
    MatDividerModule,
    MatMenuModule,
    MatStepperModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    ApiService,
    // AnimateService,
    SafeStylePipe,
  ],
  bootstrap: [LandingPageComponent],
  exports: [],
})
export class MainModule {}
